import { Route, Routes } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { CommsTabs } from '../components/bulk/CommsTabs';
import { CampaignDetail } from '../components/bulk/CampaignDetail';
import { CampaignList, InfoRequests, ResponsesQueue, TemplatesTab } from '../components/bulk/BulkTabs';
import { Reports } from '../components/bulk/Reports';

const VIEWS = { bulk: CampaignList, requests: InfoRequests, templates: TemplatesTab, responses: ResponsesQueue, reports: Reports };

export default function BulkComms({ view }) {
  const View = VIEWS[view] || CampaignList;
  return (
    <div className="h-full flex flex-col min-h-0" data-testid={`bulk-comms-${view}`}>
      <div className="flex items-center gap-3 px-4 py-3 border-b border-border">
        <Megaphone className="w-5 h-5 text-primary" />
        <h1 className="font-headings text-xl font-bold text-foreground">Communications</h1>
      </div>
      <CommsTabs />
      <div className="flex-1 overflow-y-auto">
        {view === 'bulk' ? <Routes><Route index element={<CampaignList />} /><Route path=":id" element={<CampaignDetail />} /></Routes> : <View />}
      </div>
    </div>
  );
}
